
const UnknownWidget = () => {
    return null
}

export {
    UnknownWidget
}
